var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessages = function SvgMessages(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M17.25 14.25h2.002a2 2 0 0 0 2-2v-6.5a2 2 0 0 0-2-2H9.002a2 2 0 0 0-2 2v2m8.25 0h-10.5a2 2 0 0 0-2 2v6.5a2 2 0 0 0 2 2h1.25v2.5l4.5-2.5h4.75a2 2 0 0 0 2-2v-6.5a2 2 0 0 0-2-2Z"
  })));
};
export default SvgMessages;